import React, { useState, useRef } from "react";
import { Container, Form } from "react-bootstrap";
import { common } from "../js/common";
import { useLocation } from "react-router-dom";

function LoginPage() {
  const usernameElement = useRef<HTMLInputElement>(null);
  const passwordElement = useRef<HTMLInputElement>(null);

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [alert, setAlert] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const location = useLocation();
  const from = (location.state as any)?.from || "/";

  const showLoginLoading = () => {
    setIsLoading(true);
    // disable input elements
  };
  const showLoginSuccess = async () => {
    setAlert("Logged in! Redirecting...");

    //wait slightly before redirecting the user back to the main page
    await new Promise((resolve) => setTimeout(resolve, 2000));
    window.location.href = from;
  };
  const showLoginError = (error: string) => {
    setError(error);
  };

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const censoredPassword = "*".repeat(password.length);
    console.log("Login attempt:", { username, censoredPassword });

    //#TODO: validate fields
    //Form element with input elements with the required attribute already prevents submitting nothing
    // if (false) {
    //   usernameElement.current?.focus();
    //   return;
    // }

    //submit data to rest service
    try {
      showLoginLoading();

      const response = await common.fetchRestAPI("sessions", "POST", {
        username,
        password,
      });

      // Show error notice to user when credentials are invalid.
      if (response.status === 401) {
        console.info(
          "handleLogin: Response returned 401, presenting invalid credentials notice.",
        );
        setIsLoading(false);
        showLoginError("Username or password was invalid.");
        return;
      }

      // handle bad responses
      if (!response.ok) {
        throw Error(response.statusText);
      }

      // The credentials submission went through successfully, proceed with logging the user in.
      // JWT should be automatically submitted back with every response. No further handling needed.
      setIsLoading(false);
      await showLoginSuccess();
    } catch (error: any) {
      setIsLoading(false);
      let userErrorMessage =
        "Encountered an error submitting login credentials";
      console.error(`${userErrorMessage}: `, error);
      if (error instanceof Error) {
        if (error.message === "Gateway Timeout") {
          userErrorMessage = "Server Down";
        }
      }
      showLoginError(userErrorMessage);
    }
  };

  return (
    <Container className="vh-100 mx-auto p-4" style={{ maxWidth: "576px" }}>
      <div
        className="d-flex flex-column justify-content-center"
        style={{ height: "100%" }}
      >
        <a href="/">&lt; Home</a>
        <h1 className="text-center p-3">Family Recipes</h1>
        <Form onSubmit={handleLogin}>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              name="username"
              placeholder="Username"
              ref={usernameElement}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <div className="invalid-feedback"></div>
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              name="password"
              placeholder="Password"
              ref={passwordElement}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" id="submit">
            Submit
          </button>
          <p className="mt-3 mb-1">
            Don't have an account? <a href="/register">Create one</a>
          </p>
          <p>
            <a href="/forgot-password">Forgot password?</a>
          </p>
          <div
            id="loginAlertSpace"
            className="p-2 d-flex justify-content-center align-items-center"
          >
            {isLoading ? (
              <div className="m-3">
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : alert !== "" ? (
              <div className="alert alert-success" role="alert">
                <strong>{alert}</strong>
              </div>
            ) : error !== "" ? (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {error}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            ) : (
              ""
            )}
          </div>
        </Form>
      </div>
    </Container>
  );
}

export default LoginPage;
